export const StatusOptions = ["draft", "pending", "approved", "rejected"];

export const AsistanceOptions = ["João", "Maria", "Pedro", "Ana", "Lucas", "Fernanda"];

export const TagOptions = ["red", "blue", "green", "yellow", "purple", "orange"];

export const CompaignsOptions = ["Compaign 1", "Compaign 2", "Compaign 3", "Compaign 4", "Compaign 5"];

export const EtapaOptions = ["Etapa 1", "Etapa 2", "Etapa 3", "Etapa 4", "Etapa 5"];

export const PipelineOptions = ["Pipeline 1", "Pipeline 2", "Pipeline 3", "Pipeline 4", "Pipeline 5"];
